import React from 'react';
import { Box, Icon, Copy } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
var CardSpecialOfferBadge = function () {
    var t = useTranslation().t;
    return (React.createElement(Box, { justifyContent: "center", py: "xs", display: "flex", "data-testid": "cy-special-offer-badge" },
        React.createElement(Icon, { name: "tag", mr: "xs", ml: "xs", iconSize: "small", iconColor: "primary" }),
        React.createElement(Copy, { fontSize: "default", fontFamily: "bold" }, t('Shared.Common.specialOfferAvailableLabel'))));
};
export default CardSpecialOfferBadge;
